import React, { useState } from "react";
import EmployeesTarget from "./addTarget";
import EmpList from "./list";
const MainEmp = ({admin,showButton}) => {
    const [viewType, setviewType] = useState('list')
    const [editData, seteditData] = useState('')

    const editHandler = (data) => {
        console.log(data)
        if (data.id) {
            seteditData(data)
            setviewType('add')
        }



    }
    const ChangeScreen=(type)=>{
        seteditData('')
        setviewType(type)
    }
    return (
        <div className="container-fluid">
            <div style={{ display: 'flex', textAlign: 'center' }}>
                <div className={`expenseListTab ${viewType == "list" ? "active" : ""}`} onClick={() => ChangeScreen('list')} > <i className="fa fa-list" ></i></div>&nbsp;&nbsp;
               {showButton? <div className={`expenseListTab ${viewType == "add" ? "active" : ""}`} onClick={() => ChangeScreen('add')} > <i className="fa fa-plus" ></i></div>:""}

            </div>
            {viewType === 'list' ?
                <EmpList showButton={showButton} admin={admin}  editHandler={editHandler}/>
                : ""}
            {viewType === 'add' ?
                <EmployeesTarget admin={admin} editData={editData} />

                : ""}
        </div>
    )
}
export default MainEmp